// extracted by mini-css-extract-plugin
export default {"activitiesContainer":"styles_activitiesContainer__h6inQ","noData":"styles_noData__vdcL5"};